import { useState, useRef, useEffect } from "react";

// Counts up from 0 to `end` once it scrolls into view.
export default function CountUp({ end, suffix = "+", compact = false, duration = 1700 }) {
    const [val, setVal] = useState(0);
    const ref = useRef(null);
    const started = useRef(false);

    useEffect(() => {
        const el = ref.current;
        if (!el) return;
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting && !started.current) {
                        started.current = true;
                        const startTime = performance.now();
                        const step = (now) => {
                            const p = Math.min((now - startTime) / duration, 1);
                            const eased = 1 - Math.pow(1 - p, 3);
                            setVal(Math.round(eased * end));
                            if (p < 1) requestAnimationFrame(step);
                        };
                        requestAnimationFrame(step);
                        observer.unobserve(el);
                    }
                });
            },
            { threshold: 0.4 }
        );
        observer.observe(el);
        return () => observer.disconnect();
    }, [end, duration]);

    const formatter = compact
        ? new Intl.NumberFormat("en", { notation: "compact", maximumFractionDigits: 0 })
        : new Intl.NumberFormat("en");

    return (
        <span ref={ref}>
            {formatter.format(val)}{suffix}
        </span>
    );
}
